
// ## EF.Collections.QuestionsCollection
//
// Collection for the questions in a survey or assessment

  var QuestionsCollection = Chaplin.Collection.extend({
    model: EF.Models.Assessments.Question,

    constructor: function(models, options) {
      Backbone.Collection.apply(this, [models, options]);
    }
  });

  _.extend(EF.Collections.Assessments, {
    QuestionsCollection: QuestionsCollection
  });
